var React = require('react');

function Circle1Inline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"74.9901","cy":"75.5","r":"59.8027","stroke":"white","strokeOpacity":"0.35","strokeWidth":"2","key":0}),React.createElement("circle",{"cx":"75.5","cy":"75.5","r":"74.5","stroke":"white","strokeOpacity":"0.1","strokeWidth":"2","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.5625 26.0989H23.3112V52.393H15.2208V32.6303H10.5625V26.0989ZM11.5579 27.1025V31.6267H16.2162V51.3894H22.3158V27.1025H11.5579Z","fill":"white","key":2})]);
}

Circle1Inline.defaultProps = {"className":"cirecle-outline","width":"151","height":"151","viewBox":"0 0 151 151","fill":"none"};

module.exports = Circle1Inline;

Circle1Inline.default = Circle1Inline;
